<script setup>
import { onMounted } from 'vue';

const sizes = ['small', 'medium'];

const props = defineProps({
    size: {
        type: String,
        default: 'medium',
    },
    staticLoader: {
        type: Boolean,
        default: false,
    },
});

onMounted(() => {
    if (!sizes.includes(props.size)) {
        console.error(props.size + ': unkown size');
    }
});
</script>

<template>
    <div :class="$style.loader__wrapper">
        <div :class="[$style.loader, staticLoader ? $style.static : '']">
            <svg
                :class="[$style.loader_items, $style[size]]"
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 20 20"
                enable-background="new 0 0 20 20"
                xml:space="preserve"
            >
                <path fill="none" stroke="#19b5b9" stroke-width="2.3" stroke-miterlimit="10" d="M1.8,6.3C3.2,3.2,6.4,1.1,10,1.1c4.9,0,8.9,4,8.9,8.9"/>
                <linearGradient
                    id="SVGID_1_"
                    gradientUnits="userSpaceOnUse"
                    x1="6.1402"
                    y1="8.8489"
                    x2="18.0553"
                    y2="15.728"
                >
                    <stop offset="5.836640e-02" style="stop-color:#19b5b9;stop-opacity:0"/>
                    <stop offset="1" style="stop-color:#19b5b9"/>
                </linearGradient>
                <path fill="none" stroke="url(#SVGID_1_)" stroke-width="2.3" stroke-miterlimit="10" d="M2.8,15.3c1.6,2.2,4.2,3.6,7.2,3.6c4.9,0,8.9-4,8.9-8.9c0-1.3-0.3-2.5-0.8-3.7"/>
            </svg>
        </div>
    </div>
</template>

<style lang="scss" module>
.loader__wrapper {
    position: relative;
}
.loader:not(.static) {
    position: absolute;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 2em 0;
}
.loader_items {
    position: relative;
    border-radius: 50%;
    animation: spin .6s infinite linear;

    &.medium {
        width: 2.5em;
        height: 2.5em;
    }
    &.small {
        width: 1.5em;
        height: 1.5em;
    }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg) }
}
</style>
